import {
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ApiResultAllRolesModel, fetchAllRoles } from "@tecumseh/Services/RoleBasePageService";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface Parameter {
    onSuccess?: (results: ApiResultAllRolesModel) => void;
}

type HandlerType = CustomApiHandler<Parameter, ApiResultAllRolesModel>;

export const BeginLoading: HandlerType = props => {
    props.dispatch({
        type: "Custom/AllRoles/BeginFetchingContents",
    });
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await fetchAllRoles();
};

export const RequestCompleted: HandlerType = props => {
    props.dispatch({
        type: "Custom/AllRoles/SetContents",
        contentResults: props.apiResult
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const CompletedLoading: HandlerType = props => {
    props.dispatch({
        type: "Custom/AllRoles/CompletedFetchingContents",
    });
};

export const chain = [BeginLoading, SendDataToApi, RequestCompleted, ExecuteOnSuccessCallback, CompletedLoading];

const getAllRoles = createHandlerChainRunner(chain, "GetAllRoles");
export default getAllRoles;